import React from "react";

const CircularProgressBar = ({ progress, size = 100 }) => {
  const radius = size / 2;
  const angle = (progress / 100) * 360;

  // Convert angle to radians for calculations
  const radian = (angle - 90) * (Math.PI / 180);

  // Calculate end point of the arc
  const x = radius + radius * Math.cos(radian);
  const y = radius + radius * Math.sin(radian);

  // Determine if we need a large arc
  const largeArcFlag = progress > 50 ? 1 : 0;
  const progressColor = progress >= 90 ? "#cc0000" : "#1b9447";

  return (
    <svg width={size} height={size}>
      {/* Background Circle */}
      <circle
        cx={radius}
        cy={radius}
        r={radius}
        fill={progressColor} // Background color 00bcd4
      />
      {progress === 100 ? (
        // Special case for 100% progress
        <circle
          cx={radius}
          cy={radius}
          r={radius}
          fill="#e6e6e6" // Full progress color
        />
      ) : (
        // Partial progress path
        <path
          d={`M ${radius},${radius} 
              L ${radius},0
              A ${radius},${radius} 0 ${largeArcFlag} 1 ${x},${y}
              Z`}
          fill="#e6e6e6" // Progress color
        />
      )}
    </svg>
  );
};

export default CircularProgressBar;